module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_close-41c90857048a60b68b05a035d44b1c8a.svg";